import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { InputGroup, Button, Input } from 'module-tsl-ui-elements';
import WithDocgen from 'module-tsl-ui-elements/with-docs/input-group/InputGroup';
import pkg from 'module-tsl-ui-elements/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`<React.Fragment>
<InputGroup
  self={{
    groupId: 'foo',
  }}
  label={{
    text: 'Input label',
  }}
/>
<br />
<InputGroup
  self={{ groupId: '1' }}
  cta={<Button>Submit</Button>}
  customInput={<Input id="1" type="email" placeholder="Email address" />}
/>
</React.Fragment>`}
  scope={ { InputGroup, Button, Input } }
/>
<PropsTable data={WithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-elements --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  